import { a } from "@react-spring/web";
import { postWithToken } from "../authentication/AuthProvider";
import config from "../config";

export const partnership_routes = (partnership) => ({
  label: "Partnership",
  root: partnership,
  invite_partner: partnership + "/invite_partner",
  get_my_partners: partnership + "/get_my_partners",
  delete: partnership + "/delete",
  update_role: partnership + "/update_role",
  accept_partnership_invitation: partnership + "/accept_partnership_invitation",
  reject_partnership_invitation: partnership + "/reject_partnership_invitation",
  get_my_pending_invitations_received: partnership + "/get_my_pending_invitations_received",
});

export const Partnership = {
  get_my_partners: () => postWithToken(config.partnership.get_my_partners),
  accept: (invitation_id) => postWithToken(config.partnership.accept_partnership_invitation, { invitation_id }),
  reject: (invitation_id) => postWithToken(config.partnership.reject_partnership_invitation, { invitation_id }),
};
